"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Styled = __importStar(require("./StatusStyles"));
;
var Status = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? "green" : _b, _c = _a.type, type = _c === void 0 ? "status" : _c, size = _a.size, height = _a.height, width = _a.width, children = _a.children, fontSize = _a.fontSize, padding = _a.padding, _d = _a.fetching, fetching = _d === void 0 ? false : _d;
    switch (type) {
        case "ball":
            if (children) {
                return (React.createElement(Styled.StatusOuterContainer, null,
                    React.createElement(Styled.StatusBall, { variant: fetching ? "grey" : variant, size: size }),
                    fetching
                        ? React.createElement(Styled.StatusLoadingSkeleton, null)
                        : React.createElement(Styled.StatusOuterText, null, children)));
            }
            return (React.createElement(Styled.StatusBall, { variant: fetching ? "grey" : variant, size: size }));
        case "loading":
            return (React.createElement(Styled.StatusLoading, { variant: variant, height: height, width: width },
                React.createElement(Styled.LoadingAnimation, null)));
        case "circle":
            if (children) {
                return (React.createElement(Styled.StatusOuterContainer, null,
                    React.createElement(Styled.StatusCircle, { variant: fetching ? "grey" : variant, size: size }),
                    fetching
                        ? React.createElement(Styled.StatusLoadingSkeleton, null)
                        : React.createElement(Styled.StatusOuterText, null, children)));
            }
            return (React.createElement(Styled.StatusCircle, { variant: fetching ? "grey" : variant, size: size }));
        case "status":
            if (children) {
                return (React.createElement(Styled.StatusNormal, { variant: fetching ? "grey" : variant, width: width, height: height, fontSize: fontSize, padding: padding }, children));
            }
            return (React.createElement(Styled.StatusNormal, { variant: fetching ? "grey" : variant }));
    }
};
exports.default = Status;
